module.exports = __webpack_public_path__ + "static/media/attention.0f0d9be8.png";